/**
 * This is a provider of the theme property for components of react
 * as well as object literals of specific variables for direct usage in
 * in components. Normally using getTheme should be enough.
 */
import uiConfig from "../config/ui";
import dhlFonts from "./dhl/vars.fonts";

const themes = {
  dhl: {
    fonts: dhlFonts,
  },
};

/**
 * Gets the object where the fonts of the theme are defined.
 * @param {String} themeName Name of the theme for which we will get the fonts.
 */
function withFonts(themeName) {
  return themes[themeName].fonts;
}

/**
 * Gets an object that contains the theme to use in the components.
 * @param {Object} props properties of the component
 */
function getTheme(props) {
  return props.theme
    ? { ...themes[uiConfig.uiTheme], ...props.theme }
    : themes[uiConfig.uiTheme];
}

const theme = getTheme({});

export { getTheme, withFonts, theme, themes };
